import { createBrowserHistory } from 'history'
import onClient from 'components/utils/onClient'

const history = onClient ? createBrowserHistory() : null
export default history
